/**
 * 브랜드 SSOT — 프로덕트명·연락처·외부 연동 기본값
 *
 * 명칭 결정 (2026-06): 공식 프로덕트명 **PingPing** 유지.
 * - "Ping" 단독은 검색·상표·Apple/iMessage 등과 혼동, 제품 정체성 약함.
 * - PingPing = 동작(핑) + 친근함; 영문/한글 모두 발음·기억 용이.
 * - 슬로건·CTA에서만 "Send a link" / "링크 한 번" 등 동사형 카피 사용.
 */
export const BRAND = {
  productName: 'PingPing',
  legalEntity: 'Minimum Labs',
  contactEmail: 'contact@blockwavelabs.io',
  defaultLocale: 'ko',
  supportedLocales: ['ko', 'en'],
};

export function buildContactMailto({ subject, body, locale = 'ko' } = {}) {
  const defaultSubject =
    locale === 'en' ? 'PingPing — Product demo inquiry' : 'PingPing — 체험·도입 문의';
  const params = new URLSearchParams();
  if (subject || defaultSubject) params.set('subject', subject || defaultSubject);
  if (body) params.set('body', body);
  const qs = params.toString();
  return `mailto:${BRAND.contactEmail}${qs ? `?${qs}` : ''}`;
}
